import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-CU-logo_svg__graficos",
  viewBox: "0 0 234.94 169.99"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-CU-logo_svg__cls-2{fill-rule:evenodd;fill:#004fa3}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "m0 0 36.5 169.99h105.27L0 0z",
      style: {"fill-rule":"evenodd","fill":"#ef3e33"}
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M12.17 0 52.7 48.67h80.93L93.17 0h-81zM113.4 121.46l40.61 48.53h80.93l-40.47-48.53H113.4zM62.86 60.84l40.46 48.6h81.07l-40.61-48.6H62.86z",
      class: "svg-CU-logo_svg__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "CU-logo"}) } }